<template>
  <div>
    <top-nav></top-nav>
    <div class="center_container">
      <div class="crumb">社会体育指导员</div>
      <ul class="instructor_ul">
        <li class="hover_style instructor_li" v-for="index in 10" :key="index" @click="$router.push('/instructorDetails')">
          <img :src="require('@/assets/image/instructor/instructor_img'+index+'.png')"/>
          <div class="instructor_div">
            <p class="li_name">林克芳</p>
            <p class="li_p">性别：女</p>
            <p class="li_p">联系方式：16547368267</p>
            <p class="li_p">技术等级：跆拳道黑带</p>
            <ul>
              <li>跆拳道</li>
              <li>篮球</li>
              <li>足球</li>
              <li>瑜伽</li>
              <li>健身</li>
            </ul>
          </div>
        </li>
      </ul>
      <div class="display_flex" style="justify-content: center">
        <el-pagination
            :total="100"
            background
            layout="prev, pager, next">
        </el-pagination>
      </div>
    </div>

    <bot-nav></bot-nav>

  </div>
</template>

<script>
export default {
  name: "instructorIndex",
  data() {
    return {

      instructorList: [
        {
          name: '林克芳',
          sex: '女',
          phone: '16547368267',
          level: '跆拳道黑带'
        }
      ]
    }
  }
}
</script>

<style scoped lang="less">
.center_container {
  padding-bottom: 30px;
}

.instructor_ul {
  display: flex;
  flex-wrap: wrap;
  padding: 0;

  .instructor_li {
    list-style: none;
    width: calc((100% - 120px) / 5);
    margin-right: 20px;
    border: 1px solid #DCDCDC;
    margin-bottom: 20px;

    img {
      width: 100%;
    }

    &:nth-child(5n) {
      margin-right: 0;
    }

    p {
      margin: 0;
    }

    .instructor_div {
      padding: 0 22px;

      .li_name {
        font-weight: 700;
        font-size: 24px;
        color: #333333;
        margin: 16px 0 24px 0;
      }

      .li_p {
        font-weight: 400;
        font-size: 18px;
        color: #333333;
        margin-bottom: 16px;
      }

      ul {
        display: flex;
        flex-wrap: wrap;
        margin: 0;
        padding: 0;
        margin-bottom: 20px;

        li {
          list-style: none;
          width: 84px;
          height: 30px;
          background: #0058a626;
          font-size: 14px;
          color: #0058A6;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-right: 6px;
          margin-bottom: 6px;
        }
      }
    }
  }
}

</style>
